import { DEFAULT_PAGE_SIZE } from '@/fsd/entities/cashbox/model/consts/consts';
import { IPageSizeSelectOption } from '@/fsd/shared/ui/PageSizeSelect';

export const DEFAULT_OPTION: IPageSizeSelectOption = {
  name: String(DEFAULT_PAGE_SIZE),
  value: DEFAULT_PAGE_SIZE,
};
